import './test.css';
import React, { useState, useEffect, useRef } from 'react';
import parse from 'html-react-parser'
import phoebeCloseUp from'../../images/phoebeCloseUp.png'
import willieCloseUp from'../../images/willieCloseUp.png'
import { audio, playMusic, pauseMusic, setVolume, transitionVolume, stopMusic, isPlaying, playEffects, playEffectsVN, stopEffectsVN, setVolumeEffectsVN, setVolumeEffects, isPlayingEffects, playAmbient, setVolumeAmbient, transitionVolumeAmbient, stopAmbient} from '../musicEngine/musicEngine';
import checkMark from'../../m/checkMark.js'
import click from'../../m/click.js'
import test from'../../m/test.js'
import whoosh from'../../m/whoosh.js'
import achievementSound from'../../m/achievement.js'

function Test({goMenu, isLS, questionsArr, goNext, state, step, achievementsSave, language, hzAdjuster}) {
  const [saveAchievements, setSaveAchievements] = useState(0);
  //
  const bgRef = useRef(null);
  const charRefLeft = useRef(null);
  const charRefRight = useRef(null);
  const textBoxLeft = useRef(null);
  const textBoxRight = useRef(null);
  const textBoxCover = useRef(null);
  const answersBox = useRef(null);
  const answerBox0 = useRef(null);
  const answerBox1 = useRef(null);
  const answerBox2 = useRef(null);
  const answerBox3 = useRef(null);
  const wrap = useRef(null);
  const wrapTest = useRef(null);
  const arrowBack = useRef(null);
  const achievement = useRef(null);
  let exit = useRef(null);
  let help = useRef(null);
  let particles = useRef(null);
  let helpWith = useRef(null);
  //
  let stopTexting = useRef(false);
  let texting = useRef(false);
  let skipButton = useRef(false);
  let prevPosition = useRef();
  let removeChar = useRef(false);
  let backMenuCheck = useRef(false);
  let removeCharPosition = useRef(false);
  let answered = useRef(false);
  let answering = useRef(false);
  let arrowBackVisible = useRef(false);
  //
  const [charName, setCharName] = useState();
  const [numI, setNumI] = useState(0);
  const [numJ, setNumJ] = useState(0);
  const [timer, setTimer] = useState(0);
  //
  const [textBoxLeftText, setTextBoxLeftText] = useState("");
  const [textBoxRightText, setTextBoxRightText] = useState("");
  //
  useEffect(() => {

  });

  let textTranslation = {
    en:{
      test:"Test 1",
      description:"The test contains 8 multiple choices questions a, b, c with only 1 answer correct for each question. Testing time: 2 minutes.",
      askWillie:"Ask Willie what's the answer",
      askPhoebe:"Ask Phoebe what's the answer",
      a:"a.",
      b:"b.",
      c:"c.",
      finish:"Finish"
    },
    ru:{
      test:"Тест 1",
      description:"Тест содержит 8 вопросов с несколькими вариантами ответов а, б, в, для каждого вопроса есть только 1 правильный ответ. Время тестирования: 2 минуты.",
      askWillie:"Спросить у Вилли",
      askPhoebe:"Спросить у Фиби",
      a:"а.",
      b:"б.",
      c:"в.",
      finish:"Завершить"
    }
  }

  const achievementsRu = [
    "Экстраверт",
    "Душнила",
    "Знаток кисок",
    "Доппельгангер",
    "Вообще мимо",
    "Впечатлить профессорку",
    "Помощник",
    "Настоящий друг",
    "Пальцем в небо",
    "Найти жемчужину",
    "Ценитель бюстов",
    "Поклонник поп-арта",
    "Sir Camelot",
    "Остаточные знания",
    "CUMанда МОКРЕНЬКИХ",
    "Влажный сон",
    "С водный спасатель",
    "Мечтатель",
    "Комфортик",
    "В работу с головой",
    "Специалист по домашке",
    "Скользкий язычок",
    "Статист",
    "Призрачный студент",
    "Лорд Бульборектал",
    "Анатом",
    "Барабанщик",
    "Раззява"
  ];

useEffect(() => {
  document.addEventListener('deviceready', deviceReadyFunc, false);
  function deviceReadyFunc() {
    document.addEventListener('backbutton', onBackButton, false);
  }
  function onBackButton(e) {
    e.preventDefault();
    goToMenu();
  }
  return () => {
    document.removeEventListener('deviceready', deviceReadyFunc, false);
    document.removeEventListener('backbutton', onBackButton, false);
  }
},[]);

  useEffect(() => {
    start();
    async function start(){
      if(state.current[step] && state.current[step]["time"]){
        let startTime = 120 - state.current[step]["time"]
        playMusic(test, 2000, startTime);
      }else{
        playMusic(test, 2000);
      }
      setTimeout(async () => {
      await transitionVolume(0.3,1200);
    }, 100);
      if(!state.current[step]){
        state.current[step] = {test:true, time:0, hintUsed:false};
        if(isLS){
        localStorage.setItem('stateSC2', JSON.stringify(state.current));
      }
        timerSetter(120);
      }else{
        timerSetter(state.current[step]["time"]);
      }
      await initialImgsLoad();
      await changeSetting(wrap,"current.style.opacity", 0, "", 0.02);
      wrap.current.style.zIndex = 0;
    }
},[]);

useEffect(() => {
    if(isLS){
    localStorage.setItem('achievementsSave2', JSON.stringify(achievementsSave.current));
  }
},[saveAchievements]);

function initialImgsLoad(){
  return new Promise(async (resolve, reject) => {
  let loaded = 0;
  const images = document.querySelectorAll("img");
  images.forEach(async (img) => {
    if(img.complete){
      loaded++;
      if(loaded == images.length){
        resolve();
      }
    }else{
      img.onload = async () =>{
        loaded++;
        if(loaded == images.length){
          resolve();
        }
      }
    }
  });
});
}

function waitingFunc(t, loadStop){
  return new Promise(async (resolve, reject) => {
      setTimeout(f,t);
    function f(){
      resolve();
      return;
    }
  });
}

function checkBoxClick(){
playEffects(checkMark, false);
}

async function checkAnswers(){
  let rightAnswersNum=0;
  let answersNum=0;
  let specialQuestion = false;
  for(let i=0;i<questionsArr.length;i++){
    if(questionsArr[i].specialQuestion){
      specialQuestion = document.getElementById('question'+i).elements["checkbox"+i].value;
      continue;
    }
    if(document.getElementById('question'+i).elements["checkbox"+i].value === questionsArr[i].answer){
      rightAnswersNum++
    }
    answersNum++;
  }
  let testResult = answersNum - rightAnswersNum; //mistakes number
  wrap.current.style.zIndex = "16";
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
  exit.current=true;
  if(specialQuestion == false){
    state.current.splice(step, 1, {test:true, testResult:testResult, time:state.current[step]["time"], hintUsed:state.current[step]["hintUsed"]})
  }else if(specialQuestion !== false){
    state.current.splice(step, 1, {test:true, testResult:testResult, specialQuestion: specialQuestion, time:state.current[step]["time"], hintUsed:state.current[step]["hintUsed"]})
  }
  if(isLS){
  localStorage.setItem('stateSC2', JSON.stringify(state.current));
}
  document.body.classList.remove("stop-scrolling");
  try{
  navigator.vibrate(0);
}catch(e){
  console.log(e);
}
await transitionVolume(0,300);
setVolumeEffects(0.5);
playEffects(whoosh, false);
changeSetting(wrap,"current.style.zIndex", 10, "", 10);
  goNext();
  return;
}

async function timerSetter(seconds){
  return new Promise(async (resolve, reject) => {
    if(exit.current){
      return;
    }
    if(seconds<21){
      document.getElementsByClassName("timer")[0].style.color = "#a60d02";
      document.getElementsByClassName("timer")[0].style.border = "1px solid #a60d02";
      await changeSetting(document.getElementsByClassName("timer")[0],"style.fontSize", 20, "px", 0.1);
      try{
      navigator.vibrate(100);
    }catch(e){
      console.log(e);
    }
      changeSetting(document.getElementsByClassName("timer")[0],"style.fontSize", 18, "px", 0.1);
    }
  let min = Math.floor(seconds / 60);
  let sec = seconds - min*60;
  if(min<10){
    min="0"+min;
  }
  if(sec<10){
    sec="0"+sec;
  }
  let time = min+":"+sec;
  setTimer(time);
  if(exit.current){
    return;
  }
  state.current.splice(step, 1, {test:true, time:seconds, hintUsed:state.current[step]["hintUsed"]})
  if(isLS){
  localStorage.setItem('stateSC2', JSON.stringify(state.current));
}
  if((seconds-1)>=0){
      setTimeout(timerDecrease,1000);
      resolve();
      return;
  }else{
    checkAnswers();
    resolve();
    return;
  }
  async function timerDecrease(){
    await timerSetter(seconds-1);
  }
});
}

async function askforHelp(n){
  playEffects(click, false);
  helpWith.current = n;
  help.current.style.display = "block";
  wrapTest.current.style.zIndex = "10";
  await changeSetting(wrapTest,"current.style.opacity", 0.6, "", 0.03);
  document.body.classList.add("stop-scrolling");
  await changeSetting(help,"current.style.bottom", -5, "vh", 0.9);
  wrapTest.current.onclick = closeHelp;
}

async function closeHelp(){
  playEffects(click, false);
  document.body.classList.remove("stop-scrolling");
  await changeSetting(help,"current.style.bottom", -40, "vh", 3);
  help.current.style.display = "none";
  await changeSetting(wrapTest,"current.style.opacity", 0, "", 0.03);
  wrapTest.current.style.zIndex = "0";
  wrapTest.current.onclick = "";
}

async function getHelp(from){
  playEffects(click, false);
  state.current.splice(step, 1, {test:true, time:state.current[step]["time"], hintUsed:true})
  if(isLS){
  localStorage.setItem('stateSC2', JSON.stringify(state.current));
}
  wrapTest.current.onclick = "";
  await changeSetting(help,"current.style.bottom", 0, "vh", 1);
  await changeSetting(help,"current.style.bottom", -40, "vh", 2);
  help.current.style.display = "none";
  textBoxCover.current.style.display = "block";
  wrap.current.style.zIndex = "14";
  await startDialog(questionsArr[helpWith.current].hints[from]);
  await changeSetting(wrapTest,"current.style.opacity", 0, "", 0.03);
  wrapTest.current.style.zIndex = "0";
  wrap.current.style.zIndex = "0";
  wrapTest.current.onclick = "";
  document.body.classList.remove("stop-scrolling");
}


async function startDialog(dialog){
  return new Promise(async (resolve, reject) => {
  for(let i = 0; i<dialog.length; i++){
    for(let j = 0; j<dialog[i]["phrases"].length; j++){
    await textAppearing(dialog[i]["phrases"][j]["text"],dialog[i]["position"], dialog[i]["char"]);
    if(dialog[i]["phrases"][j]["achievement"] !== undefined && achievementsSave.current[dialog[i]["phrases"][j]["achievement"][3]][2] == 0){
        achievementsSave.current[dialog[i]["phrases"][j]["achievement"][3]][2] = 1;
        setSaveAchievements(previous => previous + 1);
        achievementAppear(dialog[i]["phrases"][j]["achievement"]);
    }
    await waitin();
    await textDisappearing();
  }
  }
  textBoxCover.current.style.display = "none";
  resolve();
});
}

async function goToMenu(){
  await transitionVolume(0,300);
  stopMusic();
  setVolumeEffects(0.5);
  playEffects(whoosh, false);
    wrap.current.style.zIndex = "16";
    changeSetting(wrap,"current.style.zIndex", 10, "", 10);
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
  try{
  navigator.vibrate(0);
}catch(e){
  console.log(e);
}
  exit.current=true;
  document.body.classList.remove("stop-scrolling");
  goMenu();
  return;
}

async function waitin(){
  if(exit.current){
    return;
  }
  return new Promise((resolve, reject) => {
    document.getElementById("wrap").onclick=ff;
function ff(){
  resolve();
}
});
}

function skipText(){
if(arrowBackVisible.current){
  clearTimeout(arrowBackVisible.current);
  backMenuDisappear();
}

if(texting.current){
  if(skipButton.current){
    stopTexting.current = true;
  }
}

}



async function setTextParameters(obj, setting, changeTo, speed, changeTo1, speed1, changeTo2, speed2, setting3, changeTo3, speed3, position){
  if(exit.current){
    return;
  }
  return new Promise(async (resolve, reject) => {
const props = setting
    .split(/[./[\]]/g)
    .filter(p => p);
const prop = props.pop();
const parent = props.reduce((result, key) => result[key], obj);

const props3 = setting3
    .split(/[./[\]]/g)
    .filter(p => p);
const prop3 = props3.pop();
const parent3 = props3.reduce((result, key) => result[key], obj);

changeTo = changeTo*document.body.clientWidth/100;
changeTo1 = changeTo1*document.body.clientHeight/100;
speed=2*1.7*document.body.clientWidth/100*hzAdjuster;
speed1=0.8*1.7*document.body.clientHeight/100*hzAdjuster;
speed2=0.04*1.7*hzAdjuster;
speed3=0.04*1.7*hzAdjuster;
let pre = parent[prop];
let preI,i,preI1,i1,preI2,i2;
if(pre !== "translate(0px) scale(1)" && pre.includes(",")){ //apple bug fix
preI = pre.split("translate(")[1];
i = Math.round(parseFloat(preI.split("px")[0]));
preI1 = parent[prop].split(", ")[1];
i1 = Math.round(preI1.split("px")[0]);
preI2 = parent[prop].split("scale(")[1];
i2 = Math.round(preI2.split(")")[0]);
}else{
  preI = pre.split("translate(")[1];
  i = Math.round(parseFloat(preI.split("px")[0]));
  i1=0;
  preI2 = parent[prop].split("scale(")[1];
  i2 = Math.round(preI2.split(")")[0]);
}
let i3 = Math.round(parent3[prop3]);
textAppear();
function textAppear(){
  if(exit.current){
    return;
  }
  if(i<changeTo){
    i+=speed;
    //i = parseFloat(i.toFixed(1));
    if(i>changeTo){
      i=changeTo;
    }
  }else if(i>changeTo){
    i-=speed;
  //  i = parseFloat(i.toFixed(1));
    if(i<changeTo){
      i=changeTo;
    }
  }
  if(i1<changeTo1){
    i1+=speed1;
    //i1 = parseFloat(i1.toFixed(1));
    if(i1>changeTo1 || (i==changeTo)){
      i1=changeTo1;
    }
  }else if(i1>changeTo1){
    i1-=speed1;
    //i1 = parseFloat(i1.toFixed(1));
    if(i1<changeTo1 || (i==changeTo)){
      i1=changeTo1;
    }
  }
  if(i2<changeTo2){
    i2+=speed2;
    //i2 = parseFloat(i2.toFixed(1));
    if(i2>changeTo2 || (i==changeTo)){
      i2=changeTo2;
    }
  }else if(i2>changeTo2){
    i2-=speed2;
  //  i2 = parseFloat(i2.toFixed(1));
    if(i2<changeTo2 || (i==changeTo)){
      i2=changeTo2;
    }
  }
  if(i3<changeTo3){
    i3+=speed3;
    //i3 = parseFloat(i3.toFixed(1));
    if(i3>changeTo3 || (i==changeTo)){
      i3=changeTo3;
    }
  }else if(i3>changeTo3){
    i3-=speed3;
    //i3 = parseFloat(i3.toFixed(1));
    if(i3<changeTo3 || (i==changeTo)){
      i3=changeTo3;
    }
  }
  if(position !== "center"){
    parent[prop] = "translate("+i+"px, "+i1+"px) scale("+i2+")";
  }else{
    parent[prop] = "translate(0px, "+i1+"px) scale("+i2+")";
  }
parent3[prop3] = i3;
if(i == changeTo){
  resolve();
  return;
}
  requestAnimationFrame(textAppear);
  return;
}
});
}

function changeSetting(obj, setting, changeTo, um, speed, char){
speed=speed*2*hzAdjuster;
  return new Promise((resolve, reject) => {
    const props = setting
        .split(/[./[\]]/g)
        .filter(p => p);
    const prop = props.pop();
    const parent = props.reduce((result, key) => result[key], obj);
    //
    var i;
    if(setting == "current.style.transform" || setting == "style.transform"){
      i = parseFloat(parent[prop].split("(")[1].split(")")[0]);
    }else{
      i = parseFloat(parent[prop]);
    }
    let slowDownTrigger = 0;
  //  if(char){//delete
  //slowDownTrigger = Math.round(parseFloat(Math.abs((char.initialPointX[0]-char.destinationPointX)/char.speed)*0.8));//moment of slower of char
  //}
  //  let slowDownCounter=0;
    let slower = 8;
    change();
  function change(){
    if(exit.current){
      return;
    }
    //slowDownCounter++;
  //  if(slowDownCounter > slowDownTrigger && char != undefined){ //delete
  //    slower+=3; //slower of char
  //  }
  //  console.log(slower);
    if(i>changeTo){
      i-=speed;
      if(i<changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
  }else if(i<changeTo){
    i+=speed;
    if(i>changeTo){
      i = changeTo;
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
  }else{
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else{
      parent[prop] = i+um;
    }
    resolve();
    return;
  }
  if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
    parent[prop] = "scale("+i+")";
  }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
    parent[prop] = "rotateY("+i+"deg)";
  }else{
    parent[prop] = i+um;
  }
requestAnimationFrame(change);
return;
}
});
}


async function textAppearing(text, position, name, answers){
  if(exit.current){
    return;
  }
  texting.current = true;
  stopTexting.current = false; //resetting stopTexting var
  if(name){
    setCharName(name);
  }
  if(position == "left"){
    textBoxRight.current.style.display = "none";
    textBoxLeft.current.style.display = "block";
      textBoxLeft.current.style.transform = "translate("+(-0.5)*document.body.clientWidth+"px, "+(-0.2)*document.body.clientHeight+"px) scale(0)";
      if(!answers){
        await setTextParameters(textBoxLeft, "current.style.transform", 0, 2.5, 0, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
      }else{
        await setTextParameters(textBoxLeft, "current.style.transform", 0, 2.5, -20, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
      }
      prevPosition.current = position;
  }else if(position == "right"){
    textBoxLeft.current.style.display = "none";
    textBoxRight.current.style.display = "block";
    textBoxRight.current.style.transform = "translate("+(0.5)*document.body.clientWidth+"px, "+(-0.2)*document.body.clientHeight+"px) scale(0)";
    if(!answers){
      await setTextParameters(textBoxRight, "current.style.transform", 0, 2.5, 0, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
    }else{
      await setTextParameters(textBoxRight, "current.style.transform", 0, 2.5, -20, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
    }
    prevPosition.current = position;
  }else if(position == "center"){
    textBoxRight.current.style.display = "none";
    textBoxLeft.current.style.display = "block";
    textBoxLeft.current.style.transform = "translate("+(-0.5)*document.body.clientWidth+"px, "+(-0.2)*document.body.clientHeight+"px) scale(0)";
    if(!answers){
      await setTextParameters(textBoxLeft, "current.style.transform", 0, 2.5, 0, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
    }else{
      await setTextParameters(textBoxLeft, "current.style.transform", 0, 2.5, -20, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
    }
    prevPosition.current = position;
  }
let i = 0;
let speed = 20; /* The speed/duration of the effect in milliseconds */
let txtHTML = "";
let open = "", close = "";
if(text.includes("<small><i>")){
  text = text.split("<small><i>")[1];
  text = text.split("</small></i>")[0];
  open = "<small><i>";
  close = "</small></i>";
}
await typeWriter();
if(answers){
setTimeout(fff,200);
}
function fff(){
  answersAppearing(answers);
}

//
async function typeWriter() {
  if(exit.current){
    return;
  }
  return new Promise((resolve, reject) => {
  if(text.length>5){
    if(i===6){ //setting skipbutton
      skipButton.current = true;
    }
  }else{
    skipButton.current = true;
  }
  if (i < text.length) {
    txtHTML += text.charAt(i);
    if(text.charAt(i+1)){
      txtHTML += text.charAt(i+1);
    }
    if(position === "left" || position === "center"){
        setTextBoxLeftText("<p>"+open+txtHTML+close+"</p>");
    }else if(position === "right"){
        setTextBoxRightText("<p>"+open+txtHTML+close+"</p>");
    }
    i+=2;
    if(stopTexting.current == false){
      if(i>=text.length-1){
        texting.current = false;
        skipButton.current = false;
        resolve();
      }
     setTimeout(awaitTypeWriter, speed);
     async function awaitTypeWriter(){
       await typeWriter();
       resolve();
     }
  }else if(stopTexting.current == true){
    if(position === "left" || position === "center"){
    setTextBoxLeftText("<p>"+open+text+close+"</p>");
    }else if(position === "right"){
    setTextBoxRightText("<p>"+open+text+close+"</p>");
    }
      texting.current = false;
      skipButton.current = false;
      resolve();
      return;
    }
  }
});
}
}

async function textDisappearing(){
  if(exit.current){
    return;
  }
  if(prevPosition.current == "left"){
    await setTextParameters(textBoxLeft, "current.style.transform", -50, 2.5, -20, 1, 0, 0.05, "current.style.opacity", 0, 0.05, prevPosition.current);
    setTextBoxLeftText("");
    await waitingFunc(100);
  }else if(prevPosition.current == "right"){
    await setTextParameters(textBoxRight, "current.style.transform", 50, 2.5, -20, 1, 0, 0.05, "current.style.opacity", 1, 0.05, prevPosition.current);
    setTextBoxRightText("");
    await waitingFunc(100);
  }
  else if(prevPosition.current == "center"){
    await setTextParameters(textBoxLeft, "current.style.transform", -50, 2.5, -20, 1, 0, 0.05, "current.style.opacity", 0, 0.05, prevPosition.current);
    setTextBoxLeftText("");
    await waitingFunc(100);
  }
  return;
}
 function answersDisappearing(answer){
   if(exit.current){
     return;
   }
  return new Promise(async (resolve, reject) => {
  if(answersBox.current.style.display === "flex"){
    await changeSetting(eval("answerBox"+answer),"current.style.opacity", 0, "", 0.03);
    let arr =  [0,1,2,3];
    arr.splice(answer, 1);
    for(let key in arr){
      let v = Math.floor(Math.random() * ((arr.length-1) - 0 + 1) + 0);
      await changeSetting(eval("answerBox"+arr[v]),"current.style.opacity", 0, "", 0.03);
      arr.splice(v, 1);
    }
  answersBox.current.style.display = "none";
  setTimeout(f,200);
  function f(){
    resolve();
  }
}else{
  resolve();
}
});
}
async function answersAppearing(answers){
  if(exit.current){
    return;
  }
  answersBox.current.style.display = "flex";
  let ansNum;
  for(let key in answers){
    eval("answerBox"+parseInt(key)).current.style.display = "flex";
    eval("answerBox"+parseInt(key)).current.innerHTML = answers[key];
    ansNum = key;
  }
  for(ansNum+=1;ansNum<4;ansNum++){
    eval("answerBox"+parseInt(ansNum)).current.style.display = "none";
  }
  for(let key in answers){
    changeSetting(eval("answerBox"+parseInt(key)),"current.style.transform", 1, "scale", 0.03);
    await changeSetting(eval("answerBox"+parseInt(key)),"current.style.opacity", 1, "", 0.03);
  }
}

async function answerHandler(e){
  if(answering.current){
  answering.current=false;
  await answer();
  }
    function answer(){
      if(exit.current){
        return;
      }
          return new Promise(async (resolve, reject) => {
              answered.current = e.target.innerHTML;
              if(arrowBackVisible.current){
                clearTimeout(arrowBackVisible.current);
                backMenuDisappear();
              }
              await answersDisappearing(e.target.getAttribute('name'));
              await textDisappearing();
              wrap.current.style.zIndex = 10;
              resolve();
            });
          }
}

async function backMenuAppear(){
  if(exit.current){
    return;
  }
  if(!arrowBackVisible.current && backMenuCheck.current == false){
    backMenuCheck.current = true;
    arrowBack.current.style.display = "block";
    await changeSetting(arrowBack,"current.style.opacity", 1, "", 0.03);
    arrowBackVisible.current = true;
    arrowBackVisible.current = setTimeout(() => {
  backMenuDisappear();
}, 7000);
  }
}

async function backMenuDisappear(){
  if(exit.current){
    return;
  }
  if(arrowBackVisible.current && backMenuCheck.current == true){
  backMenuCheck.current = false;
  await changeSetting(arrowBack,"current.style.opacity", 0, "", 0.01);
  arrowBack.current.style.display = "none";
  arrowBackVisible.current = false;
}
}

async function achievementAppear(achievementUnlock){
  if(exit.current){
    return;
  }
  stopEffectsVN();
  setVolumeEffectsVN(0.7);
  playEffectsVN(achievementSound, false);
  let text;
  if(language == "en"){
    text = 'Achievement unlocked!<br/>"' + achievementUnlock[1] +'"';
  }else if(language == "ru"){
    text = 'Достижение разблокировано!<br/>"' + achievementsRu[achievementUnlock[3]] +'"';
  }
  achievementUnlock[2] = 1;
  achievement.current.style.display = "flex";
  let h = achievement.current.getElementsByClassName("cup")[0].querySelectorAll("h4")[0].clientHeight+4;
  achievement.current.getElementsByClassName("cup")[0].querySelectorAll("h4")[0].style.marginTop = (40-h)/2+"px";
  await changeSetting(achievement,"current.style.transform", 1, "scale", 0.03);
  achievement.current.querySelectorAll("p")[0].innerHTML = text;
  let w = achievement.current.querySelectorAll("p")[0].clientWidth;
  await width();
  achievement.current.querySelectorAll("p")[0].style.opacity = "1";
  achievement.current.querySelectorAll("p")[0].innerHTML = '';
  var txtHTML = "", i = 0;
  await changeSetting(achievement.current.getElementsByClassName("cup")[0],"style.transform", 90, "rotateY", 3);
  achievement.current.getElementsByClassName("cup")[0].querySelectorAll("h4")[0].innerHTML = achievementUnlock[0];
   changeSetting(achievement.current.getElementsByClassName("cup")[0],"style.transform", 0, "rotateY", 3);
  setTimeout(typeWriter, 50);
  setTimeout(achievementDisappear, 3000);


  async function width(){
    if(exit.current){
      return;
    }
    return new Promise(async (resolve, reject) => {
      setTimeout(fu,300);
        async function fu(){
          if(exit.current){
            return;
          }
  await changeSetting(achievement,"current.style.width", (w+60+20), "px", 4);
  resolve();
}
});
}

  async function typeWriter() {
    if(exit.current){
      return;
    }
    return new Promise((resolve, reject) => {
    if (i < text.length) {
      txtHTML += text.charAt(i);
      if(text.charAt(i+1)){
        txtHTML += text.charAt(i+1);
      }
      achievement.current.querySelectorAll("p")[0].innerHTML = txtHTML;
      i+=2;
        if(i>=text.length-1){
          resolve();
        }
       setTimeout(awaitTypeWriter, 20);
       async function awaitTypeWriter(){
         if(exit.current){
           return;
         }
         await typeWriter();
         resolve();
       }
    }
  });
}
}

async function achievementDisappear(){
  if(exit.current){
    return;
  }
  changeSetting(achievement.current.querySelectorAll("p")[0],'style.opacity', 0, "", 0.06);
  await changeSetting(achievement,"current.style.width", 50, "px", 4);
  await disap();
  achievement.current.style.display = "none";
  async function disap(){
    return new Promise(async (resolve, reject) => {
      setTimeout(fu,300);
        async function fu(){
          if(exit.current){
            return;
          }
          await changeSetting(achievement,"current.style.transform", 0, "scale", 0.03);
  resolve();
}
});
}
}
  return (
<div className='wrapTest'>
<div className='achievement' ref={achievement} style={{transform: "scale(0)", display:"none", width:"50px", zIndex:"11", position:"fixed"}}>
<p className='achievementText' style={{opacity:"0"}}></p>
<div className='cup' style={{transform: "rotateY(0deg)"}}>
  <h4 className='achievementEmoji'>🏆</h4>
  </div>
</div>
<div className='clickWrapVN' onClick={skipText} ref={wrap} id='wrap' style={{opacity:"1",zIndex:"10"}}></div>
<div className='clickWrapVN' ref={wrapTest} id='wrapTest' style={{opacity:"0",zIndex:"0"}}></div>
<div className='backWrapVNTest' onClick={backMenuAppear} style={{opacity:"1",zIndex:"15"}}>
<div className="arrowBack3" ref={arrowBack} onClick={goToMenu} style={{opacity:"0", display:"none"}} >
    <div></div>
</div>
</div>
<img src="" className='char' ref={charRefLeft} style={{left:"-100vw", opacity:"0%", bottom:"-20vh"}}/>
<img src="" className='char' ref={charRefRight} style={{right:"0vw", opacity:"0%", bottom:"-20vh"}}/>
<div className="textBoxCover" ref={textBoxCover} style={{display:"none", zIndex:13, position:"fixed"}}>
<div className="textBox" ref={textBoxLeft} style={{left:"0vw", opacity:"0",  top:"0vh", width:"100%", transform:"translate(-50vw, -20vh)"}}><h1>{charName}</h1><div className="box-inner" id="textBoxLeft">{textBoxLeftText ? parse(textBoxLeftText) : parse(textBoxLeftText)}</div></div>
<div className="textBox" ref={textBoxRight} style={{right:"0vw", opacity:"0",  top:"0vh", width:"100%", transform:"translate(50vw, -20vh)"}}><h1>{charName}</h1><div className="box-inner" id="textBoxRight">{textBoxRightText ? parse(textBoxRightText) : parse(textBoxRightText)}</div></div>
<div className='answersVN' ref={answersBox} style={{display:"none"}}>
    <div className='answerVN' ref={answerBox0} style={{opacity:"0", display:"none", transform: "scale(0)"}} onClick={answerHandler} name="0"></div>
    <div className='answerVN' ref={answerBox1} style={{opacity:"0", display:"none", transform: "scale(0)"}} onClick={answerHandler} name="1"></div>
    <div className='answerVN' ref={answerBox2} style={{opacity:"0", display:"none", transform: "scale(0)"}} onClick={answerHandler} name="2"></div>
    <div className='answerVN' ref={answerBox3} style={{opacity:"0", display:"none", transform: "scale(0)"}} onClick={answerHandler} name="3"></div>
</div>
</div>
<div className="askHelp" ref={help} style={{display:"none", bottom:"-40vh"}}>
<svg onClick={closeHelp} className="close" xmlns="http://www.w3.org/2000/svg"  fill="#fff" height="25px" width="25px" version="1.1" id="Capa_1" viewBox="0 0 490 490">
<polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490   489.292,457.678 277.331,245.004 489.292,32.337 "/>
</svg>
<ul>
<li onClick={() => {getHelp(0)}} value="1">
<div className='pic'>
<img className='img' style={{width:"110%", marginLeft:"-4%"}} src={phoebeCloseUp} alt="" />
</div>
<h2>{textTranslation[language]["askPhoebe"]}</h2>
</li>
<li  value="2" onClick={() => {getHelp(1)}}>
<div className='pic'>
<img className='img' style={{width:"110%", marginLeft:"0%"}} src={willieCloseUp} alt="" />
</div>
<h2>{textTranslation[language]["askWillie"]}</h2>
</li>
</ul>
</div>

<div className="timer" style={{fontSize:"18px"}}>
<h2>{timer}</h2>
</div>

<div className="test">
<h1>{textTranslation[language]["test"]}</h1>
<p>{textTranslation[language]["description"]}</p>
<div className="questions">

{questionsArr.map((item,index)=>{
  return(
<div className="question" key={index}>
<form id={"question"+index}>
<h2>{index+1}. {parse(item.question)}</h2>
{item.img && <img src={item.img}/>}
<ul>
<li>
<div className="checkbox-wrapper" onClick={checkBoxClick}>
  <input type="radio" className="check"  name={"checkbox"+index} id={"checkbox-"+index+"-1"} value="a"/>
  <label htmlFor={"checkbox-"+index+"-1"}>
  <svg viewBox="0 0 65 65" height="35" width="35">
    <rect x="7" y="7" width="50" height="50" stroke="#000" fill="none" />
    <g transform="translate(-23,-967)">
      <path d="m 53,978 c -73,1 46,71 15,2 C 60,959 30,966 30,707" stroke="#08023d" fill="none" stroke="black" strokeWidth="4" className="path" />
    </g>
  </svg>
    {textTranslation[language]["a"]} {item.answers[0]}
  </label>
</div>
</li>
<li>
<div className="checkbox-wrapper" onClick={checkBoxClick}>
  <input type="radio" className="check"  name={"checkbox"+index} id={"checkbox-"+index+"-2"} value="b"/>
  <label htmlFor={"checkbox-"+index+"-2"}>
  <svg viewBox="0 0 65 65" height="35" width="35">
    <rect x="7" y="7" width="50" height="50" stroke="#000" fill="none" />
    <g transform="translate(-23,-967)">
      <path d="m 53,978 c -73,1 46,71 15,2 C 60,959 30,966 30,707" stroke="#08023d" fill="none" stroke="black" strokeWidth="4" className="path" />
    </g>
  </svg>
    {textTranslation[language]["b"]} {item.answers[1]}
  </label>
</div>
</li>
<li>
<div className="checkbox-wrapper" onClick={checkBoxClick}>
  <input type="radio" className="check"  name={"checkbox"+index} id={"checkbox-"+index+"-3"} value="c"/>
  <label htmlFor={"checkbox-"+index+"-3"}>
  <svg viewBox="0 0 65 65" height="35" width="35">
    <rect x="7" y="7" width="50" height="50" stroke="#000" fill="none" />
    <g transform="translate(-23,-967)">
      <path d="m 53,978 c -73,1 46,71 15,2 C 60,959 30,966 30,707" stroke="#08023d" fill="none" stroke="black" strokeWidth="4" className="path" />
    </g>
  </svg>
    {textTranslation[language]["c"]} {item.answers[2]}
  </label>
</div>
</li>
</ul>
</form>
{state.current[step] && !state.current[step]["hintUsed"] && item.hints && <svg onClick={() => {askforHelp(index)}} className="questionMark"  xmlns="http://www.w3.org/2000/svg"  fill="#734c0e" height="10vw" width="10vw" version="1.1" id="Capa_1" viewBox="0 0 29.536 29.536"><g> 	<path d="M14.768,0C6.611,0,0,6.609,0,14.768c0,8.155,6.611,14.767,14.768,14.767s14.768-6.612,14.768-14.767   C29.535,6.609,22.924,0,14.768,0z M14.768,27.126c-6.828,0-12.361-5.532-12.361-12.359c0-6.828,5.533-12.362,12.361-12.362   c6.826,0,12.359,5.535,12.359,12.362C27.127,21.594,21.594,27.126,14.768,27.126z"/> 	<path d="M14.385,19.337c-1.338,0-2.289,0.951-2.289,2.34c0,1.336,0.926,2.339,2.289,2.339c1.414,0,2.314-1.003,2.314-2.339   C16.672,20.288,15.771,19.337,14.385,19.337z"/> 	<path d="M14.742,6.092c-1.824,0-3.34,0.513-4.293,1.053l0.875,2.804c0.668-0.462,1.697-0.772,2.545-0.772   c1.285,0.027,1.879,0.644,1.879,1.543c0,0.85-0.67,1.697-1.494,2.701c-1.156,1.364-1.594,2.701-1.516,4.012l0.025,0.669h3.42   v-0.463c-0.025-1.158,0.387-2.162,1.311-3.215c0.979-1.08,2.211-2.366,2.211-4.321C19.705,7.968,18.139,6.092,14.742,6.092z"/>	<g> 	</g> 	<g> 	</g> 	<g> 	</g> 	<g> 	</g> 	<g> 	</g> 	<g> 	</g> 	<g> 	</g> 	<g> 	</g> 	<g> 	</g> 	<g> 	</g> 	<g> 	</g> 	<g> 	</g> 	<g> 	</g> 	<g> 	</g> 	<g> 	</g> </g> </svg>}
</div>
);
})}
<button onClick={checkAnswers}>{textTranslation[language]["finish"]}</button>
</div>
</div>
</div>
  );
}

export default Test;
